import type { NeutralPalette } from '../schema/MiniPalette';

export const NEUTRAL_LIGHT_THEME_PALETTE: NeutralPalette = {
    black: '#000000',
    white: '#ffffff',
    whiteTranslucent50: 'rgba(255,255,255,.5)',
    blackTranslucent20: 'rgba(0,0,0,.2)',
    blackTranslucent50: 'rgba(0,0,0,.5)',
    blackTranslucent60: 'rgba(0,0,0,.6)',
    blackTranslucent90: 'rgba(0,0,0,.9)',

    textDominant: '#212121',
    textPrimary: '#212121',
    textSecondary: '#6e6e6e',
    textSecondaryHC: '#303030',
    textDisabled: '#acacac',
    textOnAccent: '#ffffff',

    iconPrimary: '#6e6e6e',
    iconSecondary: '#919191',
    iconDisabled: '#acacac',
    iconOnAccent: '#ffffff',

    surfacePrimary: '#ffffff',
    surfacePrimary2: '#ffffff',
    surfacePrimaryElevated: '#ffffff',
    surfaceSecondary: '#f8f8f8',
    surfaceTertiary: '#f1f1f1',
    surfaceQuaternary: '#e1e1e1',

    dividerPrimary: '#e1e1e1',
    dividerSecondary: '#c8c8c8',
    dividerTertiary: '#c8c8c8',
    dividerQuaternary: '#919191',

    overlay: 'rgba(0, 0, 0, 0.6)',

    omOpxBottomSheetBackground: '#FFFFFF',

    blue: '#0078d4',
    slateDark: '#3b3a39',

    successPrimary: '#13a10e',
    successShade20: '#0f7a0b',
    dangerPrimary: '#d92c2c',
    dangerShade20: '#a52121',
    dangerTint30: '#f4b9b9',
    warningTint10: '#FFD94E',
    warningShade20: '#c2a129',
    warningTint40: '#fff8df',

    // Common
    headerForeground: '#ffffff',

    // Calendar
    rsvpBackground: '#f3f2f1',
    allInstancesEndBanner: '#828282',

    // Search
    searchHighlightBackground: '#fff848',
    searchHighlightBorder: '#af851a',

    // Brands
    teams: '#6264a7',
    skype: '#0078d4',

    // Mail
    mailSelectedBackground: '#eaf5ff',
    mailRPSubjectBackground: '#f8f8f8',
    mailRPBackground: '#f1f1f1',

    // People
    transparentDarkBg: '#ffffff00',
    orgChartBorder: '#c8c8c8',
    orgChartPersonBg: '#EFF6FC',
    dividersPrimary: '#e1e1e1',

    // Oboarding
    carouselBg: '#f6f4f7',

    // Misc
    skeletonBg: '#eaeaea',
    toggleBg: '#f1f1f1',
    bottomSheetSecondaryButtonText: '#0078D4',

    // MeControl
    meControlAccountItemBg: 'rgba(0,0,0,.04)',
    meControlAccountItemBgActive: 'rgba(0,0,0,.08)',

    // MeControl campaign card
    snackBarBg: '#EAEAEA',

    // USQ warning text
    warningText: '#817400',

    //NPS Button outline
    buttonOutlinePrimary: '#c7e0f4',
};
